/*
 * @Descripttion: 
 * @version: 
 * @Author: szj
 * @Date: 2023-06-13 09:20:34
 * @LastEditors: szj
 * @LastEditTime: 2025-03-28 11:27:18
 */
import { App, reactive } from "vue";
import { getFlyNum } from '/@/api/sys/sys'
import { sysType } from '/@/types/task'
import { ELocalStorageKey } from "/@/types";
import { getMapDataApi, mapUrlList, safeParseFloat } from '/@/utils/common'
// import * as Cesium from "cesium";
// import { Viewer, Rectangle } from "cesium";
// import "cesium/Build/Cesium/Widgets/widgets.css";
// import CesiumNavigation from "cesium-navigation-es6";

export function useGMapManage() {
  const state = reactive({
    theLayergmap: null as any,
    mapInstancegmap:null as any,
    handler:null as any,
    mouseHandler:null as any,
  });
  const mapFormState = reactive({
    lng: 104.1192570206,
    lat: 30.6245513446,
    maps: 1, // 1 为 ceisum, 2为星图 3 为自有
    mapsxyz: []
  })
  async function initMap(DOMNAME: string, app: App, pos:any) {
    const sceneOptions = () => {
      let lng = safeParseFloat(mapFormState.lng)
      let lat = safeParseFloat(mapFormState.lat)
      if (pos && pos.length > 0) {
        lng = safeParseFloat(pos[0])
        lat = safeParseFloat(pos[1])
      }
      if (!lng) {
        lng = 104.1192570206
      }
      if (!lat) {
        lat = 30.6245513446
      }
      let option = {
        scene: {
          // alt: 1739851  pitch:-30
          center: { lat: lat, lng: lng, alt: 5000, heading: 1},
          // center: { lat: 30.654566, lng: 104.092518, alt: 10000, heading: 1 },
          showSun: true,
          showMoon: false,
          showSkyBox: true,
          showSkyAtmosphere: true,
          fxaa: true,
          backgroundColor: "#ffffff",
          globe: {
            show: true,
            baseColor: "#005d96",
            showGroundAtmosphere: false,
            // enableLighting: true,
            depthTestAgainstTerrain: false,
            // depthTestAgainstTerrain: true,
          },
          cameraController: {
            enableCollisionDetection: true,
          },
        },
        control: {
          homeButton: false,
          sceneModePicker: false,
          baseLayerPicker: false,//隐藏默认底图选择控件
        },
        basemaps: [
          // {
          //   show: true,
          //   name: "Satellite",
          //   type: "xyz",
          //   url: "https://ga.cdrzwx.cn:1111/{z}/{x}/{y}/tile.png",
          //   imageryProvider: new Cesium.UrlTemplateImageryProvider({
          //     url:"https://ga.cdrzwx.cn:1111/{z}/{x}/{y}/tile.png",
          //   }),
          //   minimumLevel: 3,
          //   maximumLevel: 19,
          // },
          // {
          //   show: true,
          //   name: "img",
          //   type: "image",
          //   // url: "Earth Map.jpg",
          //   url: "http://localhost/data/Img/earth/Earth Map.jpg",
          //   // dayAlpha: 0.1,
          //   // nightAlpha: 1.0,
          //   brightness: 0.9,
          //   minimumLevel: 1,
          //   maximumLevel: 1,
          // },
          {
            name: "卫星图",
            icon: "",
            type: "group",
            show: true,
            layers: [
              {
                maximumLevel: 16,
                type: "tdt",
                layer: "img_d",
                // crs: "WGS84",
                crs: "EPSG:4326",
                // key: et.Token.tiandituArr,
                key: mapUrlList.ces_token,
              },
              {
                type: "tdt",
                layer: "img_z",
                // crs: "WGS84",
                crs: "EPSG:4326",
                // key: et.Token.tiandituArr,
                key: mapUrlList.ces_token,
              },
            ],
          },
        ],
      };
      // delete option.terrain;
      return option;
    };    
    state.mapInstancegmap = await new et.Map(`${DOMNAME}`, await sceneOptions());
    await initSetting(app);
    state.mapInstancegmap.viewer.cesiumWidget._showRenderLoopErrors = false; // 关闭默认错误弹框
    // 挂在到全局
    // app.config.globalProperties.$viewer = state.viewer;
    app.config.globalProperties.$mapinstancegmap = state.mapInstancegmap;
  }
  async function initSetting(app: App) {
    state.theLayergmap = new et.layer.GraphicLayer({
      name: "graphicLayer",
    });
    app.config.globalProperties.$theLayergmap = state.theLayergmap;
    state.mapInstancegmap.addLayer(state.theLayergmap);
    
    state.handler = new Cesium.ScreenSpaceEventHandler(state.mapInstancegmap._viewer.scene.canvas)
    app.config.globalProperties.$handler = state.handler;
    state.mouseHandler = new Cesium.ScreenSpaceEventHandler(state.mapInstancegmap._viewer.scene.canvas)
    app.config.globalProperties.$mouseHandler = state.mouseHandler;
    // console.log(145,mapFormState);
    // await loadNavigation(state.mapInstancegmap._viewer)
    
    // 1 为 cesium
    if (mapFormState.maps == 1) {
      // cesium 高程
      state.mapInstancegmap._viewer.terrainProvider = Cesium.createWorldTerrain({
        requestVertexNormals: false,
        requestWaterMask: false,
      });
    }else if (mapFormState.maps == 2) {
      // 2 为星图
      // 切换图层
      // 瓦片 图层
      const TDT_SL = new Cesium.UrlTemplateImageryProvider({
          url: mapUrlList.xin_imgUrl,
          minimumLevel: 3,
          maximumLevel: 22,
          type: "xyz",
      })
      state.mapInstancegmap._viewer.imageryLayers.addImageryProvider(TDT_SL);
      // 切换高程
      const terrainProvider1 = new Cesium.CesiumTerrainProvider({
        url: mapUrlList.xin_treeain,
      });
      state.mapInstancegmap._viewer.terrainProvider = terrainProvider1;
    }else if (mapFormState.maps == 3) {
      // 3 为自有
      // 瓦片 图层
        const TDTs = new Cesium.UrlTemplateImageryProvider({
          url: mapUrlList.own_imgurl,
          minimumLevel: 3,
          maximumLevel: 22,
          type: "xyz",
      })
      state.mapInstancegmap._viewer.imageryLayers.addImageryProvider(TDTs);
      // 切换高程
      const terrainProvider2 = new Cesium.CesiumTerrainProvider({
        url: mapUrlList.own_treeain,
      });
      state.mapInstancegmap._viewer.terrainProvider = terrainProvider2;
    }else if (mapFormState.maps == 4) {
      // 4 为mapbox
      // 瓦片 图层
      const TDTs = new Cesium.UrlTemplateImageryProvider({
        url: mapUrlList.mapbox_imgurl,
        minimumLevel: 3,
        maximumLevel: 22,
        type: "xyz",
      })
      state.mapInstancegmap._viewer.imageryLayers.addImageryProvider(TDTs);
      // cesium 高程
      state.mapInstancegmap._viewer.terrainProvider = Cesium.createWorldTerrain({
        requestVertexNormals: false,
        requestWaterMask: false,
      });
    }
    // 是否显示arcgis 图层
    if (mapUrlList.arcgisShow) {
        // 创建 ArcGIS 地图服务的影像提供者
      // const arcGisImageryProvider = new Cesium.ArcGisMapServerImageryProvider({
      //   url: mapUrlList.arcgis1,
      // });
      // state.mapInstancegmap._viewer.imageryLayers.addImageryProvider(arcGisImageryProvider);
      const arcGisImageryProvider2 = new Cesium.ArcGisMapServerImageryProvider({
        url: mapUrlList.arcgis2,
      });
      state.mapInstancegmap._viewer.imageryLayers.addImageryProvider(arcGisImageryProvider2);
    }
  }
  async function globalPropertiesConfig(app: App, pos:any) {
    // initMap(id, app);
    await getMapData()
    initMap("g-container", app, pos);
  }
  // 获取地图默认参数
  async function getMapData() {
    const workspaceId: string = localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
    const res = await getFlyNum({sysName:sysType[2].key}, workspaceId)
    // console.log(93,res);
    if (res.code == 0) {
        if (res?.data?.sys_value) {
            const sysValue = JSON.parse(res?.data?.sys_value)            
            mapFormState.lng = sysValue?.lng ? safeParseFloat(sysValue?.lng) || 104.1192570206 : 104.092518
            mapFormState.lat = sysValue?.lat ? safeParseFloat(sysValue?.lat) || 30.6245513446 : 30.654566
            mapFormState.maps = sysValue?.maps ? sysValue?.maps : 1
            mapFormState.mapsxyz = sysValue?.mapsxyz ? sysValue?.mapsxyz : []
        }
    }
  }
  // 指北针
  function loadNavigation(viewer1:any) {
    let viewer = viewer1;
    let options = {} as any;    
    options.defaultResetView = Cesium.Cartographic.fromDegrees(mapFormState.lng, mapFormState.lat,10000);
    options.enableCompass= false; // 罗盘
    options.enableZoomControls= false; // 缩放控件
    options.enableDistanceLegend= true; // 距离图例
    options.enableCompassOuterRing= false; // 指南针外环
    viewer.extend(Cesium.viewerCesiumNavigationMixin, options);
}
  return {
    globalPropertiesConfig,
  };
}
